import { Flex } from "@engaging-tech/components"
import styled from "styled-components"

const BlurWrapper = styled(Flex)`
  filter: ${({ enableInsight }) => (enableInsight ? "none" : "blur(0.5rem)")};
`

export default BlurWrapper
